<template>
    <div class="container">
        <div class="banner-content">
            <img src="@/assets/brand/banner.png" alt="">
        </div>
        <div class="brand-process" ref="ppjj">
            <img src="@/assets/brand/bander01.jpg" style="width: 100%;" alt="">
            <!-- <div class="brand-cmp">
                <div class="ip-logo"><img src="@/assets/brand/whitelogo.png" style="
                width: 414px;height: auto;" alt=""></div>
                <p class="brand-text">帮消费者省钱   帮加盟商赚钱   帮员工更值钱</p>
            </div>     
            <div class="swiper-text">
                <swiper :options="swiperOption">
                    <swiper-slide><div class="swiper-text-line">创立于2019年江西宜春，赵一鸣以量贩零食为经营核心,连同集团下其他品牌，构成了庞大的超14,000家门店网络，覆<br>盖中国28个省份和所有线级城市。</div></swiper-slide>
                    <swiper-slide><div class="swiper-text-line">赵一鸣以“省钱就逛赵一鸣”为价值主张，坚持让利消费者，把货卖便宜，致力于为<br> 全国人民省钱。</div></swiper-slide>
                    <swiper-slide><div class="swiper-text-line">2024年9月，赵一鸣省钱超市重磅升级，采用“零食+”模式，引入更丰富的品类如日<br>化、玩具、短保烘焙等，引领高质平价零售新变革，不断满足消费者以「省钱价」实<br>现高品质生活的强烈号召，实现「为人民省钱，做社区基建」的经营使命！</div></swiper-slide>
                </swiper>
                <div class="swiper-icon swiper-right"></div>
                <div class="swiper-icon swiper-left"></div>
            </div> -->
            <div ref="pplc" class="process-title">
                <img src="@/assets/brand/title_history.png" style="width: 432px;height: auto;margin-bottom: 42px;
                " alt="">
                 
            </div>
            <div class="swiper-history">
                <div class="swiper-history-imgs">
                    <swiper ref="historySwiper" :options="historySwiperOption">
                        <swiper-slide v-for="(item,index) in processData" :key="index" class="history-item">
                            <div class="swiper-timeline-item">{{ item.time }}<i class="icon-point"></i></div>
                            <div class="swiper-img-content">
                                <div class="swiper-img"><img :src="item.url" style="height: 243px;" alt=""></div>
                                <p class="swiper-text" v-html="item.content"></p>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-time-icon swiper-time-right"></div>
                    <div class="swiper-time-icon swiper-time-left"></div>
                </div>
            </div>
            <!--品牌IP-->
            <div ref="ppip" class="content-bg">
                <div class="brand-content">
                    <div class="brand-img"><img src="@/assets/brand/title_IP.png" alt=""></div>
                    <div class="ip-content">
                        <div :class="{'ip-left':true}">
                            <img :class="{'show-ip-img':ipSwiperIndex===0}" :src="ipImgs[0]" alt="">
                            <img :class="{'show-ip-img':ipSwiperIndex===1}" :src="ipImgs[1]" alt="">
                            <img :class="{'show-ip-img':ipSwiperIndex===2}" :src="ipImgs[2]" alt="">
                            <img :class="{'show-ip-img':ipSwiperIndex===3}" :src="ipImgs[3]" alt="">
                        </div>
                        <div class="ip-dialog">
                            <swiper ref="ipSwiperRef" :options="ipSwiperOptions">
                                <swiper-slide v-for="(item,index) in ipInfos" :key="index">
                                    <div :class="{'ip-box':true, 'changeBox':index === 2 }">
                                        <p v-if="index !== 2" class="ip-title" style="white-space: nowrap;">{{ item.title1 }}</p>
                                        <p v-if="index !== 2" class="ip-subtitle">{{ item.title2 }}</p>
                                        <p v-if="index === 2" class="ip-title">
                                            <span>{{ item.title1 }}</span>
                                            <span class="ip-subtitle">{{ item.title2 }}</span>
                                        </p>
                                        <!-- <p class="ip-entitle">{{ item.entitle1 }}</p>
                                        <p class="ip-entitle">{{ item.entitle2 }}</p> -->
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-ip-icon swiper-ip-right"></div>
                            <div class="swiper-ip-icon swiper-ip-left"></div>
                            <div class="swiper-ip-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
            <!--核心优势-->
            <div ref="hxys" class="core-wrapper">
                <div class="brand-img"><img src="@/assets/brand/title_Strength.png" style="width: 432px;height: auto;margin-bottom: 52px;" alt=""></div>
                <div class="core-content">
                    <div class="core-img">
                        <img :src="coreImg" alt="">
                        <span class="stroke-text">{{ coreIndexText }}</span>
                    </div>
                    <ul class="core-list">
                        <li :class="'core-item core-item-'+index" v-for="(item,index) in coreData" v-on:mouseover="hoverCoreItem(index,item.imgUrl)" v-on:mouseout="hoverCoreItem(0,coreData[0].imgUrl)">
                            <div v-show="currentCoreIdx !== index" class="core-normal">
                                <div class="core-index">{{ item.index }}</div>
                                <div class="core-title-1">{{ item.title }}</div>
                                <div class="core-title-2">{{ item.title1 }}</div>
                            </div>
                            <div v-show="currentCoreIdx === index" class="core-active-item">
                                <div class="core-active-tag">{{ item.title }}</div>
                                <div class="core-active-title">{{ item.title2 }}</div>
                                <div class="core-active-content">{{ item.content }}</div>
                                <i class="core-active-flag"></i>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                swiperOption:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:true,
             
                    navigation: {
                        nextEl: '.swiper-left',
                        prevEl: '.swiper-right',
                    }
                },
                historySwiperOption:{
                    slidesPerView : 4,
                    navigation: {
                        nextEl: '.swiper-time-left',
                        prevEl: '.swiper-time-right',
                        disabledClass:'swiper-time-disabled'
                    }
                },
                ipSwiperOptions:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:true,
                    autoplay:{
                        delay:500000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-ip-left',
                        prevEl: '.swiper-ip-right',
                    },
                    pagination: {
                        clickable:true,
                        el: '.swiper-ip-pagination'
                    },
                    on:{
                        slideChange:()=>{
                            this.changeSlideIndex();
                        }
                    }
                },
                processData:[
                    {time:'2019.01',url:require("@/assets/brand/2019年01月.png"),content:'品牌成立，首家直营店开业'},
                    {time:'2020.10',url:require("@/assets/brand/202110.png"),content:'全面开放加盟'},
                    {time:'2023.02',url:require("@/assets/brand/202302.png"),content:'黑蚁资本领投获融资1.5亿元'},
                    {time:'2023.11',url:require("@/assets/brand/202311.png"),content:'赵一鸣零食&零食很忙战略合并鸣鸣很忙集团'},
                    // {time:'2023.12',url:require("@/assets/brand/202312.png"),content:'获好想你、盐津铺子控股，共同投资10.5亿元'},
                    {time:'2024.03',url:require("@/assets/brand/202403.png"),content:'举办万物生长伙伴大会，是行业内首个万人盛事'},
                    {time:'2024.06',url:require("@/assets/brand/202406.png"),content:'集团行业第一，门店数超1万家'},
                    {time:'2024.07',url:require("@/assets/brand/202407.png"),content:'双品牌官宣代言人周杰伦'},
                    {time:'2024.09',url:require("@/assets/brand/202409.png"),content:'全新升级赵一鸣省钱超市'},
                    {time:'2025.02',url:require("@/assets/home/process-28.jpg"),content:'引领量贩零食3.0  2025鸣鸣很忙省钱发布会'},
                    {time:'2025.07',url:require("@/assets/home/process-27.jpg"),content:'零食很忙携手赵一鸣零食  举办2025零食音乐节'},
                    {time:'2025.09',url:require("@/assets/home/process-26.jpg"),content:'鸣鸣很忙集团门店总数突破20000家'},
                    // {time:'2023.12',url:require("@/assets/brand/2023-12.jpg"),content:'2023年12月，获得好想你和盐津铺子控股合计10.5亿元投资'},
                    // {time:'2024.04',url:require("@/assets/brand/2024-3.jpg"),content:'2024年3月，举办“万物生长”伙伴万人大会'},
                    // {time:'2024.05',url:require("@/assets/brand/2024-4.jpg"),content:'2024年5月，赵一鸣零食全国门店突破4000家'},
                ],
                ipInfos:[
                    {title1:'我叫赵一鸣！',title2:'你也可以叫我鸣宝',entitle1:'My name is Zhao Yiming!',entitle2:'You can also call me Ming Bao'},
                    {title1:'头戴m眼罩 胸前鸣标',title2:'身穿披风的省钱小超人',entitle1:'I enjoy eating snacks, watching live shows,',entitle2:'and making friends the most.'},
                    {title1:'我的梦想是\n帮消费者省钱\n帮加盟商赚钱\n帮员工更值钱',title2:'',entitle1:'Buy snacks, look for SuperMing.',entitle2:''},
                    {title1:'呆萌可爱喜欢收集超级',title2:'质价比的好产品',entitle1:'Snack Connoisseur',entitle2:'Brand Ambassador'},
                ],
                ipImgs:[require("@/assets/brand/img_IPmin_1.png"),
                require("@/assets/brand/img_IPmin_2.png"),
                require("@/assets/brand/img_IPmin_3.png"),
                require("@/assets/brand/img_IPmin_4.png")],
                ipSwiperIndex:0,
                coreData:[
                    {index:'01',title:'产品多',title1:'共提供超3,300款产品SKU，约25%为厂商专门定制',title2:'共提供超3,300款产品SKU，约25%为厂商专门定制',content:'我们构建了初选、试吃、试卖、推广的标准化选品决策机制。从用户需求出发，令我们形成了品类丰富、高质价比、高频上新的产品组合，充分满足消费者多样化需求。',imgUrl:require('@/assets/brand/chanpingduo.png')},
                    {index:'02',title:'价格低',title1:'万店大集采 省钱买大牌',title2:'万店大集采 省钱买大牌',content:'与更多生产企业建立强关系，从源头拿货确保品质，同时提高商品的流转效率，从而实现超低的零售价格。',imgUrl:require('@/assets/brand/jiagedi.png')},
                    {index:'03',title:'更新快',title1:'每月上新百款产品',title2:'每月上新百款产品',content:'为消费者带来新鲜、惊喜的产品体验，引领休闲食品饮料行业的口味趋势。',imgUrl:require('@/assets/brand/gengxinkuai.png')},
                    {index:'04',title:'体验好',title1:'品牌规范 评分管理',title2:'品牌规范 评分管理',content:'始终为消费者谋福利，以规范管理建立更好的服务，通过总部强管控，从上而下构建良好的门店形象与购物体验。',imgUrl:require('@/assets/brand/tiyanhao.png')},
                ],
                currentCoreIdx:0,
                coreIndexText:'01',
                coreImg:require('@/assets/brand/chanpingduo.png')
            }
        },
        computed:{},
        mounted(){
            this.linkPos();
        },
        watch:{
            $route(to,from){
                if(to.query.block){
                    this.linkPos();
                }
            }
        },
        methods:{
           changeSlideIndex(){
                this.ipSwiperIndex = this.$refs.ipSwiperRef.swiper.activeIndex%4
           },
           hoverCoreItem(index,imgUrl){
                this.currentCoreIdx = index;
                this.coreIndexText = '0'+(index+1);
                this.coreImg = imgUrl;
           },
            linkPos(){
                const route = this.$route;
                const ref = route.query.block;
                if(ref){
                    const el = this.$refs[ref]
                    el.scrollIntoView(); 
                }
            }
        }
    }
</script>
<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/brand/index.vue